export const fa = {
  welcome: 'خوش آمدید',
  logout: 'خروج',
  trading_accounts: 'حساب معاملاتی',
  account_list: 'لیست حساب',
  create_live_account: 'ایجاد حساب واقعی',
  upgrade_to_live_account: 'ارتقاء به حساب واقعی',
  create_demo_account: 'ایجاد حساب آزمایشی',
  finance: 'مالی',
  deposit_funds: 'واریز وجه',
  withdraw_funds: 'برداشت وجه',
  internal_transfer: 'انتقال داخلی',
  external_transfer: 'انتقال خارجی',
  transfer_back: 'برگشت انتقال',
  transfer_back_to_my_local_depositor: 'برگشت انتقال به واریز کننده محلی',
  transfer_to_external_account: 'انتقال به حساب خارجی',
  payment_history: 'سوابق پرداخت',
  my_cards: 'کارت های من',
  my_profile: 'پروفایل من',
  personal_information: 'اطلاعات شخصی',
  change_password: 'تغییر پسورد',
  upload_documents: 'بارگذاری مدارک',
  partner: 'همکار',
  overview: 'نگاه اجمالی',
  clients: 'مشتریان',
  sub_ibs: 'زیر شاخه های معرف',
  payout: 'پرداخت',
  marketing_material: 'مسائل بازاریابی',
  withdrawal_history: 'سوابق برداشت',
  become_a_partner: 'همکار ما شوید',
  please_fill_the_following_fields: 'لطفا قسمت های زیر را پر کنید',
  what_geographic_region: 'منطقه جغرافیایی مد نظر شما چیست؟',
  submit: 'ارسال',
  upload_documents_notice: 'برای تایید کامل حساب و انجام معاملات, <a>لطفا مدارک خود را بارگذاری کنید</a>',
  change_password_ta_notice: 'تمامی حساب های جدید از پسورد جدید شما استفاده خواهند کرد. این موضوع حساب های قدیمی شما را تحت تاثیر نخواهد داد.',
  changepass_error: 'پسورد موجود اشتباه است, لطفا دوباره تلاش کنید',
  changepass_success: 'پسورد با موفقیت تغییر کرد',
  current_password: 'پسورد موجود',
  new_password: 'پسورد جدید',
  confirm_new_password: 'تایید پسورد جدید',
  pending_account: 'حساب در حال انتظار',
  account_must_be_approved_message: 'حساب شما قبل از افتتاح حساب معاملاتی جدید باید تایید شود',
  new_trading_account_message: 'حساب معاملاتی جدید با موفقیت ایجاد شد',
  password_generated_for_ta: 'پسورد جدید برای حساب معاملاتی شما ایجاد و به آدرس ایمیلتان ارسال  شد',
  new_trading_account_type_message: 'حساب {type} معاملاتی جدید با موفقیت ایجاد شد ',
  choose_your_desired_trading_platform_and_settings: 'پلتفرم و تنظیمات دلخواه خود را انتخاب کنید',
  select_leverage: 'انتخاب اهرم',
  create: 'ایجاد',
  select_account_type: 'انتخاب نوع حساب',
  select_currency: 'انتخاب ارز',
  no_trading_account_found: 'هیچ حساب معاملاتی یافت نشد',
  bankwire_notice:
    'ممنون که اطلاعات بانکی خود را ارسال کردید ما اطلاعات شما را در بانک خود ثبت خواهیم کرد. <br><br> شما اطلاعات الکترونیکی را به همراه شماره ارجاع شخصی, از طریق ایمیل در کمتر از 24 ساعت دریافت خواهید کرد. شما می توانبد از این اطلاعات برای پرداخت های بعدی استفاده کنید. <br><br><strong>مهم :</strong> شماره ارجاع برای یک مشتری شخصی سازی شده. اگر شما از شماره ارجاع پرداختی که دریافت کرده اید استفاده نکنید ما واریز شما را قبول نمی کنیم. شخص ثالثی قادر به استفاده از این شماره ارجاع پرداخت نیست.',
  deposit: 'واریز',
  account_details: 'اطلاعات حساب',
  enter_fasapay_id: 'لطفا شناسه حساب fasapay خود را وارد کنید',
  account_id: 'شناسه حساب',
  continue: 'ادامه',
  // bankwire_details_notice: 'Our bank requires your bank details in order to process your deposit. Any deposits made via Wire Transfer will be returned to the same account from which you deposited.',
  bankwire_deposit_details_notice:
    'بانک ما اطلاعات بانک شما را برای پردازش واریز شما احتیاج دارد. هر واریزی از طریق انتقال الکترونیکی به حساب مبداء که واریز را انجام داده برگشت داده خواهد شد',
  bankwire_withdrawal_details_notice:
    'بانک ما اطلاعات بانک شما را برای پردازش برداشت شما احتیاج دارد. هر برداشتی از طریق انتقال الکترونیکی به حساب مبداء که برداشت را انجام داده برگشت داده خواهد شد',
  bankwire_verify_account_notice: '<p>شما باید قبل از انتقال الکترونیکی حساب خود را تایید کنید. لطفا <a href="{FSROOT_URL}upload-documents">مدارک خود را بارگذاری کنید</a></p>',
  bankwire_amount_label: 'مبلغ ({minDeposit} حداقل واریز)',
  bank_name: 'نام بانک',
  full_name: 'نام کامل',
  deposit_methods: 'روش واریز وجه',
  deposit_select_ta_p: 'لطفا حسابی که مایل به واریز وجه در آن هستید را انتخاب کنید:',
  coming_soon: 'به زودی',
  amount: 'مبلغ',
  proof_of_id: 'اثبات هویت',
  proof_of_id_instructions: 'اثبات هویت',
  documents_must_contain_all_of_the_following_details: 'مدارک باید شرایط زیر را دارا باشند :',
  your_full_name: 'نام کامل شما',
  a_unique_id_number: 'شماره شناسایی منحصر به فرد',
  your_birthdate: 'تاریخ تولد',
  your_place_of_birth: 'محل تولد',
  a_visible_photo: 'عکس واضح',
  your_signature: 'امضاء',
  your_nationality: 'ملیت',
  proof_of_residence_instructions: 'لطفا قبض یا صورتحساب بانکی خود را بارگذاری کنید',
  your_residential_address: 'آدرس محل سکونت',
  date_of_issue: 'تاریخ صدور',
  other: 'دیگر',
  other_documents_instructions: 'مدارک دیگری که توسط واحد تایید حساب ما درخواست شده است',
  deposit_failed: 'واریز انجام نشد',
  deposit_successful: 'واریز با موفقیت انجام شد',
  already_logged_in: 'قبلا وارد شده اید',
  login: 'ورود',
  create_an_account: 'ایجاد حساب',
  partner_clients: 'همکار - مشتریان',
  trades: 'معاملات',
  client_id: 'شناسه مشتری',
  trading_account: 'حساب معاملاتی',
  platform: 'پلتفرم',
  order: 'سفارش',
  pair: 'جفت ارز',
  volume: 'حجم',
  close_date: 'تاریخ بسته شدن',
  commission: 'کمیسیون',
  status: 'وضعیت',
  total_commission_generated: 'مجموع کمیسیون ایجاد شده',
  total_deposits: 'مجموع واریز',
  total_withdrawals: 'مجموع برداشت',
  date_joined: 'تاریخ مشارکت',
  more: 'بیشتر',
  banners: 'آگهی ها',
  partner_marketing_material: 'همکار - ملزومات بازاریابی',
  partner_overview: 'همکار - نگاه اجمالی',
  partner_payout: 'همکار - پرداخت',
  partner_payout_request_message: 'درخواست شما ثبت شد',
  select_your_default_payment_option: 'روش پرداخت پیش فرض خود را انتخاب کنید :',
  beneficiary_name_on_account: 'صاحب سود (اسم روی حساب)',
  bank_address: 'آدرس بانک',
  sorty_code_if_applicable: 'کد طبقه بندی (در صورت امکان)',
  your_provider_email: 'ایمیل  {provider} شما ',
  select: 'انتخاب',
  next: 'بعدی',
  please_confirm_your_bank_details: 'لطفا اطلاعات بانکی خود را تایید کنید :',
  bank: 'بانک',
  sub_partners: 'زیر شاخه های همکار',
  state: 'استان',
  date: 'تاریخ',
  internal_transfer_instructions:
    'شما می توانید وجوه را بین حساب های خود انتقال دهید.<br>لطفا مقدار انتقالی خود را وارد کرده و حساب مبداء و حساب مقصد خود را انتخاب کنید.<br>انتقال داخلی سریعا انجام خواهد شد.',
  transfer_complete: 'انتقال انجام شد',
  transfer_from: 'فرم انتقال',
  internal_transfer_processed_successfully: 'انتقال داخلی با موفقیت انجام شد',
  external_transfer_processed_successfully: 'انتقال خارجی با موفقیت انجام شد',
  select_account: 'انتخاب حساب',
  to: 'به',
  warning_currency_conversion_will_take_place: 'هشدار: تبدیل ارز انجام خواهد شد',
  transfer: 'انتقال',
  account: 'حساب',
  currency: 'ارز',
  balance: 'موجودی',
  equity: 'موجودی لحظه ای',
  download: 'دانلود',
  launch: 'اجرا',
  email: 'ایمیل',
  password: 'پسورد',
  forgot: 'را فراموش کردم',
  forgot_password: 'پسورد را فراموش کردم',
  risk_warning_footer:
    'هشدار ریسک : معاملات بر روی محصولات با خاصیت اهرمی  مانند فارکس و CFD , به دلیل میزان ریسکی برای سرمایه شما ایجاد می کند, ممکن است برای همه سرمایه گذاران مناسب نباشد. لطفا اطمینان حاصل کنید که از سطح مهارت خود و همچنین مخاطراتی که سرمایه موجود در حساب شما را تهدید می کند, آگاهی کاملی دارید و در صورت لزوم دیگر توصیه های مربوطه را مد نظر قرار دهید . لطفا مطالعه شود <a href="{brokerURL}assets/pdf/risk-disclosure.pdf?v={urlRandomString}">افشاء ریسک</a>.',
  error_contact_support: 'اشتباهی رخ داده, لطفا با پشتیبانی تماس بگیرید',
  type: 'نوع',
  funded: 'سرمایه گذاری شده',
  username: 'نام کاربری',
  company_name: 'نام شرکت',
  website: 'وب سایت',
  first_name: 'نام',
  last_name: 'نام خانوادگی',
  date_of_birth: 'تاریخ تولد',
  gender: 'جنسیت',
  phone: 'شماره تلفن',
  dial_code: 'کد شماره تلفن',
  country: 'کشور',
  address: 'آدرس',
  year_moved_to_address: 'تاریخ نقل مکان به آدرس',
  post_code: 'کد پستی',
  selected_currency: 'ارز انتخابی',
  january: 'ژانویه',
  february: 'فوریه',
  march: 'مارچ',
  april: 'آپریل',
  may: 'می',
  june: 'ژوئن',
  july: 'جولای',
  august: 'آگوست',
  september: 'سپتامبر',
  october: 'اکتبر',
  november: 'نوامبر',
  december: 'دسامبر',
  already_have_an_account: 'قبلا حساب باز کرده اید',
  invalid_request_login_required: 'درخواست نا معتبر,  ابتدا باید وارد شوید',
  register_accounttype_account: 'ثبت نام حساب {accountType}',
  client_type: 'نوع مشتری',
  individual: 'شخص',
  company: 'شرکت',
  company_information: 'اطلاعات شرکت',
  company_website: 'وب سایت شرکت',
  complete_live_registration: 'تکمیل ثبت نام واقعی',
  title: 'عنوان',
  confirm_password: 'تایید پسورد',
  select_country: 'انتخاب کشور',
  phone_number: 'شماره تلفن',
  choose_trading_platform: 'انتخاب پلتفرم معاملاتی',
  select_option: 'انتخاب گزینه',
  day: 'روز',
  month: 'ماه',
  year: 'سال',
  company_registration_information: 'اطلاعات ثبت شرکت',
  date_of_registration: 'تاریخ ثبت',
  select_nationality: 'انتخاب ملیت',
  nationality: 'ملیت',
  select_gender: 'انتخاب جنسیت',
  male: 'مرد',
  female: 'زن',
  address_line: 'آدرس',
  city_town: 'شهر',
  state_province: 'استان',
  select_year: 'انتخاب سال',
  year_moved_to_current_address: 'تاریخ نقل مکان به آدرس',
  company_shareholders_directors: 'مدیران و سهامداران شرکت',
  number_of_shareholders: 'تعداد سهامداران',
  number_of_directors: 'تعداد مدیران',
  shareholder: 'سهامدار',
  financial_information: 'اطلاعات مالی',
  total_estimated_net_worth: ' برآورد ارزش خالص کل دارائی ها (€)?',
  less_than_amount: 'کمتر از {amount}',
  over_amount: 'بیشتر از {amount}',
  total_estimated_annual_income: 'برآورد مجموع درآمد سالیانه (€)?',
  employment_information: 'اطلاعات اشتغال',
  employment_status: 'وضعیت اشتغال',
  employed: 'شاغل',
  self_employed: 'خود اشتغالی',
  retired: 'بازنشسته',
  student: 'دانشجو',
  unemployed: 'بیکار',
  source_of_income: 'منبع درآمد',
  employment: 'اشتغال',
  inheritance: 'ارث',
  investment: 'سرمایه گذاری',
  trading_experience: 'مهارت معاملاتی',
  forex_cfds_and_other_instruments: 'فارکس , CFD  و دیگر ابزارها',
  yes: 'بله',
  no: 'خیر',
  lose_capital_risk:
    'با توجه به ریسک موجود, ابزار مشتقه برای اهداف و اولویت های سرمایه گذاری من مناسب بوده و من قادر به ارزیابی خطراتی که معاملات ایجاد می کنند, که حتی ممکن است منجر به از دست رفتن کل سرمایه شود, می باشم.',
  prev_pro_qualifications: 'من تجربه کار و تاییدیه حرفه ای در زمینه صنایع خدمات مالی را دارا هستم',
  account_type: 'نوع حساب',
  choose_currency: 'انتخاب ارز',
  tos_with_link:
    'من توافق همکاری, بیانیه افشاء ریسک, توافق افتتاح حساب و سیاست های امنیتی شرکت را آنطور که نمایش داده شده, مطالعه, درک و قبول کرده ام <a target="_blank" href="{URL}">اینجا</a>',
  registration_successful: 'ثبت نام با موفقیت انجام شد',
  reset_password_invalid_link: 'لینک تغییر شما نامعتبر است, لطفا مجددا تلاش کنید یا با پشتیبان تماس بگیرید',
  reset_account_password: 'تغییر پسورد حساب',
  choose_your_new_password: 'پسورد جدید خود را انتخاب کنید',
  reset_password: 'تغییر پسورد',
  file_upload_failed_filename: 'در خواست بارگذاری مدرک {filepath} انجام نشد',
  withdrawal_request_success_message: 'درخواست برداشت شما با موفقیت انجام شد',
  withdraw: 'برداشت',
  please_fill_the_following: 'لطفا جاهای خالی را پر کنید',
  cancel: 'لغو',
  withdraw_select_ta_p: 'لطفا حسابی که مایلید از آن برداشت شود را انتخاب کنید',
  free_margin_change_warning: 'لطفا توجه داشته باشید که برداشت باید به همان روشی انجام شود که از طریق آن واریز به حساب را انجام داده اید.',
  you_need_an_ib_account_to_visit_this_page: 'شما برای بازدید از این صفحه به حساب معرف احتیاج دارید',
  no_permission_to_to_visit_this_page: 'شما مجاز به بازدید از این صفحه نیستید',
  you_became_a_partner_successfully: 'شما با موفقیت همکار یوروتریدر شدید',
  note_wallet_currency_conversion_partner:
    'لطفا توجه داشته باشید که به محض اینکه همکار یوروتریدر شدید ,ارز کیف پول شما به دلار تغییر پیدا کرده و تمام پول موجود در آن با نرخ موجود به دلار تبدیل می شود!',
  upgraded_to_a_live_account_successfully: 'با موفقیت به حساب واقعی ارتقاء یافت',
  passwords_dont_match: 'پسورد همخوانی ندارد',
  password_rules: 'حداقل یک حرف بزرگ, یک حرف کوچک و یک عدد ( 6 الی حداکثر 16 علامت)',
  please_fill: 'لطفا پرکنید',
  partner_verify_first_notice: 'برای اینکه همکار ما شوید لطفا حساب خود را تایید کنید. لطفا مدارک خود را بارگذاری کنید <a href="upload-documents">اینجا</a>',
  only_currency_format_allowed: 'فقط قالب ارزی مجاز است',
  please_enter_your_account_id: 'لطفا شناسه حساب خود را وارد کنید.',
  min_deposit_with_bankwire_is_amount: 'حداقل واریزی از طریق انتقال بانکی الکترونیکی {amount}',
  please_select_different_tas: 'لطفا حساب معاملاتی متفاوتی را انتخاب کنید',
  you_need_to_accept_our_tos: 'لازم است شما  شرایط و ضوابط ما را قبول کنید.',
  phone_is_required: 'شماره تلفن نیاز است',
  invalid_phone_number: 'شماره تلفن نامعتبر است',
  you_must_be_over_18: 'سن شما باید بیشتر از 18 سال باشد',
  year_is_required: 'سال مورد نیاز است',
  leave_page_question: 'خروج از صفحه ؟',
  registration_exit_notice: 'شما فرآیند ثبت نام را کامل نکرده اید, آیا مایلید بدون اتمام فرآیند خارج شوید؟',
  internal_server_error_support: 'خطای سرور داخلی, لطفا با پشتیبانی تماس بگیرید',
  please_fill_all_fields: 'لطفا تمام بخش ها را پر کنید',
  no_logs_found_for_this_client: 'هیچ صورت عملیاتی برای مشتری پیدا نشد',
  no_accounts_send: 'هیچ حسابی ارسال نشد',
  internal_server_error_try_again: 'خطای سرور داخلی , لطفا مجددا تلاش کنید',
  insufficient_balance: 'موجودی کافی نیست',
  currency_conversion_connection_error: 'پاسخی از سرور تبدیل ارز دریافت نشد, لطفا مجدد تلاش کنید یابا پشتیبان تماس بگیرید',
  currency_conversion_error: 'خطای تبدیل ارز, لطفا مجدد تلاش کنید یا با پشتیبان تماس بگیرید',
  invalid_accounts: 'حساب نامعتبر است',
  withdrawal_unsuccessful_equity_message: 'برداشت ناموفق, موجودی کافی در حساب معاملاتی {TAID} وجود ندارد',
  withdrawal_failed_free_margin: 'برداشت ناموفق, لطفا مارجین آزاد خود را مجددا بررسی کنید.',
  pamm_copy_server_field_message: 'لطفا آدرس IP را در قسمت سرور متاتریدر4 کپی کنید',
  invalid_request: 'درخواست نامعتبر',
  missing_shareholders_directors: 'فاقد سهام دار یا مدیر',
  missing: 'فاقد اطلاعات',
  invalid_request_passwords_do_not_match: 'درخواست نامعتبر, پسورد همخوانی ندارد',
  email_exists_message: 'آدرس ایمبل قبلا ثبت شده, لطفا با ایمیل دیگری تلاش کنید',
  your_payment_method_has_already_been_set: 'روش پرداخت شما قبلا تعیین شده. لطفا با پشتیبانی تماس بگیرید',
  payment_method_is_required_message: 'روش پرداخت لازم است, لطفا با پشتیبانی تماس بگیرید',
  couldnt_find_your_account: 'حساب شما یافت نمی شود',
  ta_limit_error_message: 'حساب شما به محدودیت حساب های معاملاتی ({limit}) برای {platform} رسیده است.',
  error: 'خطا',
  account_created_successfully: 'حساب با موفقیت ایجاد شد',
  invalid_leverage: 'اهرم نامعتبر است',
  insufficient_data_provided: 'اطلاعات کافی وارد نشده است',
  insufficient_data_provided_missing_field: 'اطلاعات کافی وارد نشده است. فاقد{field}.',
  invalid_amount: 'مبلغ نامعتبر است',
  account_taid_doesnt_exist: 'حساب {TAID} وجود ندارد',
  withdrawal_unsuccessful_equity_taid: 'برداشت ناموفق, موجودی کافی در حساب معاملاتی {TAID} وجود ندارد',
  withdrawal_unsuccessful_free_margin_taid: 'برداشت ناموفق, مارجین آزاد کافی در حساب معاملاتی {TAID} وجود ندارد',
  internal_server_error: 'خطای سرور داخلی',
  deposit_failed_support: 'واریز ناموفق بود, لطفا با پشتیبانی تماس بگیرید',
  upload_documents_instructions: 'لطفا مدارک ذیل را به ما ارائه کنید.<br>فایل ها را باید در قالب PDF, JPEG یا PNG ارسال کنید و حجم فایل نباید بیشتر از 5 مگابایت باشد.',
  total_earned: 'مجموع دریافت',
  total_paid: 'مجموع پرداخت',
  total_clients: 'مجموعه زیرشاخه ها',
  total_sub_ibs: 'مجموع زیرشاخه های معرف',
  see_trading_accounts: 'دیدن حساب های معاملاتی',
  see_trades: 'دیدن معاملات',
  welcome_title_live: 'از شما بابت افتتاح حساب در یوروتریدر تشکر می کنیم!',
  welcome_title_demo: 'از شما بابت افتتاح حساب آزمایشی در یوروتریدر تشکر می کنیم!',
  welcome_title_ib: 'از شما بابت افتتاح حساب همکاری با یورو تریدر تشکر می کنیم!',
  welcome_text_live:
    '<p>به منظور افتتاح , تایید حساب و شروع معاملات شما باید مراحل زیر را طی کنید:</p><ul><li>وارد فضای کاربری یوروتریدر شوید</li><li>مدارک خود را بارگذاری کنید</li><li>واریز وجه به حساب</li><li>شروع معاملات!</li></ul><p>تیم پشتیبانی ما به صورت 24 ساعته در دسترس شماست, ما مشتاقانه پاسخگوی هر نوع سوال و در خواست شما هستیم <a href="{contactURL}" target="_blank">اینجا</a></p>',
  welcome_text_demo:
    '<p>به منظور افتتاح, تایید حساب و شروع معاملات شما باید مراحل زیر را طی کنید:</p><ul><li>پلتفرم متاتریدر4 را دانلود کنید <a href="{platformDownloadURL}">اینجا</a></li><li>مهارت های معاملاتی خود و سرعت اجرای دستورات ما را امتحان کنید</li><li>وارد درگاه مشتریان شده و حساب معاملاتی خود را به حساب معاملاتی واقعی ارتقاء دهید</li><li>مدارک خود را بارگذاری کنید و واریز وجه به حساب خود را انجام دهید</li><li>در بزرگتربن بازار مالی دنیا شروع به معامله کنید!</li></ul><p>تیم پشتیبانی ما به صورت 24 ساعته در دسترس شماست, ما مشتاقانه پاسخگوی هر نوع سوال و درخواست شما هستیم <a href="{contactURL}" target="_blank">اینجا</a></p>',
  bankwire_passports_notice: 'مهم : برای انتقال وجه الکترونیکی , شناسائی شما باید از طریق پاسپورت انجام شود',
  tracking_links: 'لینک ردیابی',
  proof_of_residence: 'اثبات محل سکونت',
  login_to_your_account: 'وارد حساب خود شوید',
  register: 'ثبت نام',
  open_demo_account: 'افتتاح حساب آزمایشی',
  create_partner_account: 'ایجاد حساب همکاری',
  ib_payout_msg_monthly_payment: 'پرداخت ها به صورت ماهانه و با روشی که شما تعیین کرده اید پرداخت می شود. پرداخت ها در اولین و پانزدهمین روز کاری هر ماه انجام می شود',
  payout_selection_complete: 'روش پرداخت انتخاب شده است',
  home: 'خانه',
  about: 'درباره ما',
  account_types: 'انواع حساب',
  spreads: 'اسپرد',
  funding: 'سرمایه گذاری',
  education: 'آموزش',
  contact: 'ارتباط با ما',
  forex_broker: 'کارگذاری فارکس',
  services_provided_by: 'خدمات مالی ارائه شده توسط Eurotrade Global Ltd',
  footer_certificate_eurotrader:
    'Eurotrade SA (Pty) Ltd (“Eurotrader”) is a subsidiary of Eurotrade RGB Holdings Ltd (HE367109) and is an authorized financial services provider, licensed and regulated by the Financial Sector Conduct Authority (FSCA) in South Africa with license number FSP <a href="https://www.fsca.co.za/Fais/Search_FSP.htm" style="color: #e04ef8; text-decoration: underline" target="_blank">44351</a> with registered address at 74 Walmer street, Sydenham, Johannesburg, 2192, South Africa.<br /><br /><!-- ‘Eurotrader’ is a registered brand of Eurotrade Investments RGB Ltd, a Cypriot Investment Firm (CIF) under the Registration Number HE317893, licensed and regulated by the Cyprus Securities and Exchange Commission (CySEC) under license 279/15 with registered address at 70, Kyrillou Loukareos Street, Kakos Premier Tower, 1st Floor, 4156 Limassol, Cyprus. Card processing will be completed by Eurotrade Investments RGB Ltd.<br /><br /> -->Eurotrader does not provide services to residents of certain jurisdictions including the USA, Iran, Canada, the Democratic Republic of Korea, Belgium, Japan, and is not intended for distribution to, or use by, any person in any country or jurisdiction where such distribution or use would be contrary to local law or regulation.<br /><br />Eurotrade SA (PTY) Ltd does not actively target EU clients.',
  footer_risk_warning:
    'هشدار ریسک : معاملات بر روی محصولات با خاصیت اهرمی  مانند فارکس و CFD , به دلیل میزان ریسکی برای سرمایه شما ایجاد می کند, ممکن است برای همه سرمایه گذاران مناسب نباشد. لطفا اطمینان حاصل کنید که از سطح مهارت خود و همچنین مخاطراتی که سرمایه موجود در حساب شما را تهدید می کند, آگاهی کاملی دارید و در صورت لزوم دیگر توصیه های مربوطه را مد نظر قرار دهید . لطفا مطالعه شود <a  href="{brokerURL}assets/pdf/risk-disclosure.pdf?v={urlRandomString}"  >افشاء ریسک</a>.',
  open_live_account: 'افتتاح حساب واقعی',
  not_registered_with_question: 'در یوروتریدر ثبت نام نکرده اید؟',
  forgot_password_q: 'پسورد خود را فراموش کرده اید؟',
  pending_deposit_success: 'عملیات با موفقیت انجام شد, واریز شما در انتظار تایید است',
  your_card_will_be_charged_cny: 'کارت شما به مقدار   <b>{amount}</b> CNY شارژ خواهد شد',
  currency_conversion_info: 'اطلاعات تبدیل ارز',
  min_deposit_is_amount: 'حداقل واریز {amount} است',
  min_transfer_is_amount: 'حداقل انتقال {amount} است',
  local_depositor: 'واریز کننده محلی',
  converted_amount: 'مقدار تبدیل شده',
  from_currency: 'از ارز',
  to_currency: 'به ارز',
  reference_id: 'شناسه ارجاع',
  from_account: 'از حساب',
  to_account: 'به حساب',
  from_date: 'از تاریخ',
  to_date: 'تا تاریخ',
  target_account_id: 'شناسه حساب هدف',
  wallet: 'کیف پول',
  received: 'دریافت شد',
  send: 'ارسال شد',
  sender_not_a_transfer_account: 'ارسال کننده, واریز کننده محلی نمی باشد',
  withdrawal_failed_support: 'برداشت ناموفق بود, لطفا با پشتیبانی تماس بگیرید',
  clear: 'پاک کردن',
  transfer_completed_successfully: 'انتقال با موفقیت انجام شد',
  receive: 'دریافت',
  view_trades: 'دیدن معاملات',
  your_provider_account_number: 'شماره حساب {provider} شما',
  your_bitcoin_address: 'آدرس بیتکوین شما',
  your_crypto_address: 'آدرس {crypto} شما',
  destination_tag: 'تگ مقصد',
  change_trading_account_password: 'پسورد حساب معاملاتی خود را تغییر دهید',
  your_card_will_be_charged_thb: 'کارت شما به مقدار <b>{amount}</b> THB  شارژ خواهد شد',
  dashboard: 'داشبورد',
  sent: 'ارسال شد',
  client_state_approved: 'تایید شد',
  client_state_pending: 'در حال انتظار',
  open_trades: 'معاملات باز',
  trade_history: 'سوابق معاملات',
  search_trades: 'جستجوی معاملات',
  trade_no: 'شماره معامله',
  symbol: 'نماد',
  open_price: 'قیمت باز شدن',
  close_price: 'قیمت بسته شدن',
  datetime: 'تاریخ و زمان',
  my_bonuses: 'پاداش های من',
  bonus: 'پاداش',
  conversion_progress: 'پیشرفت تبدیل',
  front_of_id: 'روی کارت شناسایی',
  back_of_id: 'پشت کارت شناسایی',
  include_account_in_bonus_program: 'من می خواهم به برنامه معاملاتی تأمین  سرمایه 111 ٪ ملحق شوم.',
  invest_under_master_account: 'سرمایه گذاری تحت حساب اصلی',
  i_accept_the_terms_of_service: 'من ضوابط خدمات را می پذیرم',
  pamm_master_locks_withdrawals: 'این حساب پم, برداشت در زمانی که معاملات باز وجود دارد را محدود کرده است',
  open_p_l: 'سود و ضرر معاملات باز',
  p_l: 'سود و ضرر',
  gains_prc: 'درصد سود',
  max_drawdown: 'حداکثر افت سرمایه',
  bonus_tos_with_link: 'من شرایط و ضوابط برنامه معاملاتی تأمین سرمایه<a target="_blank" href="{URL}"> 111٪ را خوانده و درک کرده ام</a>.',
  all_time: 'کل تاریخ',
  last_month: 'ماه گذشته',
  last_week: 'هفته گذشته',
  last_3_days: 'سه روز گذشته',
  monthly_avg: 'میانگین ماهانه',
  profit: 'سود',
  create_and_attach: 'ایجاد و اتصال حساب',
  attach: 'اتصال حساب',
  create_and_attach_new_pamm_account: 'ایجاد و اتصال حساب پم جدید',
  select_a_pamm_account_to_attach: 'انتخاب یک حساب پم برای اتصال',
  enter_private_code: 'رمز شخصی را وارد کنید',
  private_code: 'رمز شخصی',
  investor_link: 'لینک سرمایه گذار',
  i_accept_the_lpoa: 'من ipoa را می پذیرم',
  invest: 'سرمایه گذاری کنید',
  view_graph: 'دیدن نمودار',
  name: 'نام',
  search: 'جستجو',
  partners: 'همکاران',
  reject_withdrawls_during_open_trades: 'برداشت در زمان معاملات باز مورد پذیرش نیست',
  private_master_account: 'حساب اصلی خصوصی',
  minimum_deposit: 'حداقل واریز',
  performance_fee: 'هزینه عملکرد',
  display_name: 'نمایش نام',
  new_master_account: 'حساب اصلی جدید',
  pamm_statistics: 'آمار حساب پم',
  pamm: 'پم',
  volume_traded: 'حجم معامله شده',
  apply_date_range: 'اعمال بازه زمانی',
  pamm_master_locks_deposits: 'این حساب اصلی پم, واریزها را در زمان معاملات باز محدود کرده است',

  // new with vue
  bitcoin: 'بیتکوین',
  register_live_account: 'ثبت نام حساب واقعی',
  register_partner_account: 'ثبت نام حساب همکار',
  register_demo_account: 'ثبت نام حساب آزمایشی',
  risk_disclosure: 'افشاء ریسک',
  address_line_2: 'آدرس 2',
  skype_id: 'شناسه اسکایپ',
  password_rules_extended: 'پسورد باید حداقل شامل : 1 حرف بزرگ, 1حرف کوچک, 1 عدد و یک حرف خاص باشد. طول پسورد حداقل باید بین 8 تا 16 حرف باشد.',
  login_information: 'اطلاعات ورود',
  director: 'مدیر',
  pmethod_visa_mastercard: 'ویزا / مستر کارت',
  pmethod_visa_mastercard_alternative: 'ویزا / مستر کارت.',
  pmethod_bitcoin: 'بیتکوین',
  pmethod_bankwire: 'انتقال الکترونیکی',
  pmethod_fasapay: 'Fasapay',
  pmethod_ideal: 'ایده آل',
  pmethod_instant_bank_transfer: 'انتقال الکترونیکی در لحظه',
  pmethod_jeton: 'Jeton',
  pmethod_jeton_wallet: 'Jeton Wallet',
  pmethod_my_pay: 'MyPay',
  pmethod_neteller: 'NETELLER',
  pmethod_vload: 'VLOAD',
  pmethod_paykasa: 'Paykasa',
  pmethod_skrill: 'Skrill',
  pmethod_sofort: 'Sofort',
  pmethod_koalapay: 'KoalaPay',
  pmethod_cup: 'CUP',
  pmethod_lydiax: 'ارز دیجیتال',
  pmethod_safecharge: 'SafeCharge',
  pmethod_trustly: 'Trustly - Bank Wire',
  field_min_currency_value: 'بخش {field} باید {min} یا بیشتر باشد',
  method_deposit: 'واریز {method}',
  method_deposit_status: 'وضعیت واریز {method}',
  quick_menu: 'فهرست فوری',
  details: 'جزئیات',
  date_from: 'از تاریخ',
  date_to: 'تا تاریخ',
  from: 'از ',
  forgot_password_form_instruction: 'لطفا ایمیل خود را از قسمت زیر ارسال کنید. سپس شما در ایمیل خود لینکی را برای تغییر پسورد دریافت خواهید کرد',
  forgot_password_submit_success_message: 'لینک تغییر پسورد به ایمیل شما ارسال شده است. لطفا وارد ایمیل خود ({email}) شده و برای تغییر پسورد روی لینک کلیک کنید.',
  password_reset_successfully: 'پسورد شما با موفقیت تغییر کرد.',
  password_too_week_or_mismatch: 'پسورد انتخابی ضعیف است و یا اطلاعات وارد شده مناسب نیستند.',
  withdrawals_credit_card_remaining_amount_message: 'به منظور برداشت وجه با روش دیگر شما باید ابتدا  {amount} را برداشت و به کارت اعتباری خود برگردانید.',
  withdrawals_credit_card_refund_policy_message: 'ارائه دهندگان کارت های اعتباری تنها اجازه می دهند مجموع مقادیری را که به کارت خود برگشت زده اید, برداشت کنید .',
  withdrawals_amount_withdrawable_message: 'مجموعا {amount} می تواند به کارت شما برگشت داده شود, هر مقدار  بیشتری را می توان از طریق یکی از روش های موجود برداشت کرد.',
  country_blocked_for_this_method: 'کشور شما برای استفاده از این روش منع شده است.',
  copied_text_successfully: '{text} با موفقیت کپی شد',
  choose_wallet_currency: 'ارز کیف پول را انتخاب کنید',
  pamm_master_account_created_successfully: 'حساب اصلی پم با موفقیت ایجاد شد!',
  or_account_no_for_uk: 'یا شماره حساب ( برای مشتریان بریتانیا)',
  issue_date: 'تاریخ صدور',
  expiry_date: 'تاریخ انقضاء',
  full_copy_of_the_document: 'کپی کامل از مدارک به نحوی که 4 گوشه آن مشخص باشد',
  recent_date: 'تاریخ اخیر (بیشتر از 3 ماه نباشد)',
  your_physical_address: 'آدرس فیزیکی سکونت شما که با آدرسی که در زمان ثبت نام وارد کرده اید, مطابقت داشته باشد.',
  must_be_a_utility_bill: 'باید یکی از قبوض (آب, برق, گاز, تلفن, مالیات) یا صورتحساب بانکی باشد.',
  for_further_info_attach: 'برای مدارک بیشتر لطفا آنها را ضمیمه یک ایمیل کرده و به ایمیل persiansupport@eurotrader.com ارسال کنید.',
  banners_ad_blocker_notice: 'اگر مشکلی برای دیدن آگهی های زیر دارید لطفا نرم افزار مسدود کننده تبلیغات را غیر فعال کنید.',
  transfer_out: 'انتقال به خارج',
  transfer_in: 'انتقال به داخل',
  done: 'انجام شد',
  not_required: 'مورد نیاز نیست',
  wallet_balance: ':موجودی کیف پول',
  must_agree_terms: 'برای ایجاد حساب, شما باید با ضوابط و شرایط ما موافقت کنید.',
  select_payment_method: 'روش پرداخت خود را انتخاب کنید',
  islamic_account: 'حساب اسلامی',
  islamic_documents_instructions: 'گواهی اثبات عقاید / دین از مسجد',
  card_number: 'شماره کارت',
  expiry: 'انقضاء',
  redeem: 'خرید',
  must_be_multiple_of_10: 'مقدار باید ضریبی از 10 باشد',
  select_starting_balance: 'سرمایه اولیه خود را انتخاب کنید',
  business_name: 'نام تجارت',
  business_bank_wire_instructions: 'ساختار انتقال الکترونیکی تجارت',

  error_request_failed: 'خطا : درخواست انجام نشد',
  error_no_user_with_this_email: 'خطا: حسابی با این ایمیل یافت نشد',
  error_too_many_password_reset_requests: 'خطا: در خواست های مکرر برای تغییر پسورد انجام شده',
  error_expired_or_invalid_request: 'خطا :درخواست منقضی شده یا نامعتبر است',
  error_insufficient_wallet_balance: 'خطا: موجودی کیف پول کافی نیست',
  error_insufficient_balance_or_equity: 'خطا : موجودی کلی یا لحظه ای کافی نیست',
  error_pamm_master_deposit: 'نمی توانید به حساب اصلی پم واریز کنید',
  error_pamm_master_withdrawal: 'نمی توانید از حساب اصلی پم برداشت کنید',
  error_pamm_master_locked_deposits: 'رد درخواست : واریز به حساب در زمان باز بودن معاملات توسط حساب اصلی پم رد شده است',
  error_pamm_master_locked_withdrawals: 'رد درخواست : برداشت از حساب در زمان باز بودن معاملات توسط حساب اصلی پم رد شده است',
  error_pamm_master_minimum_deposit: 'رد درخواست : الزامات حداقل واریز مربوط به حساب اصلی پم, رعایت نشده است',
  error_live_account_already: 'حساب شما, یک حساب واقعی است',
  error_min_balance_required_is: 'حداقل موجودی مورد نیاز برای حساب {TAAccountType} ({TAID}),{min}{currency} می باشد.',
  error_transfer_same_wallet: 'امکان انتقال از کیف پول به کیف پول وجود ندارد',
  error_transfer_same_trading_account: 'امکان انتقال بین یک حساب معاملاتی وجود ندارد',
  error_no_deposit_bonus_account_deposit_restricted: 'سپرده گذاری به نوع "پاداش بدون سپرده" مجاز نیست.',
  error_no_deposit_bonus_base_amount_withdrawal: '',
  error_no_deposit_bonus_withdraw_profit_requirement_not_met: '',
  error_no_deposit_bonus_withdraw_exceeds_max_withdrawable_profit: '',
  upgrade_required_for_live_ta: 'پیش از افتتاح یک حساب معاملاتی واقعی, مشتری باید یک حساب واقعی و تایید شده داشته باشد.',
  error_wallet_currency_not_allowed_for_psp: 'برای این روش پرداخت, ارز کیف پول مجاز نیست',
  error_invalid_or_expired_otp: 'خطا: رمز یکبار مصرف ارائه شده نامعتبر یا منقضی است',
  error_max_confirmo_withdrawal_exceeded: 'خطا: حداکثر درخواست برداشت مجاز 20000 دلار/ یورو می باشد.',
  error_max_anual_vload_withdrawal_exceeded: 'خطا: مجموع میزان درخواست برداشت بیشتر از حداکثر برداشت سالیانه Vload است.',

  // Check for islamic trading account (temporarily disabled)
  is_islamic_acc_message: 'برای ایجاد حساب اسلامی لطفا درخواست خود را به persiansupport@eurotrader.com ارسال کنید تا راهنمایی بیشتری بگیرید.',
  error_invalid_voucher: 'خطا: کوپن Vload نامعتبر بوده یا قبلا استفاده شده',
  error_blocked_voucher: 'خطا: کوپن Vload به دلیل شک به کلاهبرداری مسدود شده.',
  error_voucher_data_mismatch: 'خطا: کوپن Vload به دلیل ناهمخوانی اطلاعات حساب رد شده.',
  error_vload_voucher_below_minimum: 'خطا: کوپن Vload کمتر از حداقل واریز می باشد.',
  my_bank_has_a_swift_code: 'بانک من کد سوئیفت دارد.',
  my_bank_does_not_have_a_swift_code: 'بانک من کد سوئیفت ندارد.',
  bank_not_in_swift_network_instructions: 'اگر بانک شما عضو شبکه سوئیفت نیست, برای انتقال الکترونیکی بین المللی لطفا اطلاعات بانک طرف معامله بانک خود را به ما ارائه دهید.',
  correspondent_bank_name: 'نام بانک طرف حساب',
  correspondent_bank_city: 'شهر بانک طرف حساب',
  correspondent_bank_swift: 'کد سوئیفت بانک طرف حساب',

  // New document upload strings
  proof_of_cc: 'اثبات کارت اعتباری',
  front_of_cc: 'روی کارت',
  back_of_cc: 'پشت کارت',
  proof_of_cc_instructions: 'لطفا کارت اعتباری خود را بارگذاری کنید',
  add_document: 'اضافه کردن مدرک (اختیاری)',
  cc_requirements_1: 'کپی کامل از مدارک به نحوی که 4 گوشه آن مشخص باشد',
  cc_requirements_2: 'نام کارت : کارتی که شما استفاده خواهید کرد باید دقیقا به نام خودتان باشد. هر واریزی که با کارت شخص ثالث انجام شود سریعا برگشت داده خواهد شد.',
  cc_requirements_3: 'تاریخ انقضاء: نباید کمتر از 3 ماه باشد',
  cc_requirements_4: 'شماره کارت: 6 شماره وسط کارت باید با کاغذ پوشانده شود. فقط 6 شماره اول و 4 شماره آخر باید دیده شود.',
  cc_back_requirements_5: 'کد CVV : لطفا کد CVV خود را با کاغذ بپوشانید',
  cc_back_requirements_6: 'کارت باید امضاء شده باشد.',
  click_to_add_another_document: 'قسمت بالا را کلیک کنید تا مدارک بیشتری بارگذاری کنید',
  add_up_to_4_extra_documents: 'شما می توانید حداکثر 4 مدرک دیگر را اضافه کنید.',
  add_up_to_10_extra_documents: 'شما می توانید حداکثر 10 مدرک دیگر را اضافه کنید.',
  complete_profile: 'پروفایل را کامل کنید',
  document_received: 'مدرک شما دریافت شد و توسط تیم ما بازبینی خواهد شد.',
  document_req_color: 'اینمدارک میباید که بصورت رنگی باشد.',
  internal_error: 'یک خطای داخلی رخ داده است.',
  please_enter_your_email: 'لطفا آدرس ایمیل خود را وارد کنید.',
  do_you_want_to_transform_your_trading: 'آیا می خواهید حساب معاملاتی خود را تبدیل کنید؟',
  reset_your_password_to_transfer_your_account: 'برای تبدیل حساب معاملاتی پسورد خود را تغییر دهید.',
  reset_your_old_password: 'پسورد قدیمی خود را تغییر دهید.',
  reset_password_desc: 'به دلیل انتقال سیستم , شما باید پسورد خود را به روز کنید. لطفا از قسمت زیر برای دریافت لینک تغییر پسورد, استفاده کنید',
  eurotrader_login: 'ورود به یوروتریدر  | وارد مرکز معاملات ما شوید و معاملات خود را ارتقاء دهید',
  your_email_is_verified: 'ایمیل شما قبلا تایید شده است.',
  click_here_to_login: 'برای ورود اینجا کلیک کنید',
  success_email_verified: 'با موفقیت انجام شد, ایمیل شما اکنون تایید شد',
  your_link_expired: 'لینک شما منقضی شدd',
  click_here_to_request_verification_email: 'برای درخواست جدید تایید ایمیل, اینجا کلیک کنید',
  a_new_verification_link_send: 'یک لینک جدید تایید به آدرس ایمیل شما ارسال شده است',
  invalid_request_please_check_your_link: 'درخواست نامعتبر. لطفا درستی لینک خود را بررسی و مجددا تلاش کنید',
  invalid_verification_code: 'کد تایید نامعتبر است',
  please_enter_amount: 'لطفا مقداری که مایل به واریز هستید را وارد کنید',
  bankwire_company_desc:
    '<p>اگر شما دارنده یک حساب بانکی تجاری هستید و مایلید که از طریق ثبت نام حساب تجاری با ما انتقال الکترونیکی بانکی انجام دهید لطفا مدارک مورد نظر را برای persiansupport@eurotrader.com از طریق ایمیل ارسال کنید</p><ul><li>گواهی شرکت</li><li>گواهی مدیران و دبیر درصورت وجود</li><li>گواهی سهامداران ثبت شده یا مالک</li><li>تفاهم نامه و اساسنامه</li><li>اثبات هویت و آدرس تمام سهامداران, صاحبان سود و مدیرانs.</li><li>اثبات آدرس مربوط به شرکت.</li></ul><p> درصورتی که نتوان مدارک بالا را درقالب مورد نظر ارائه کرد, یک مدرک رسمی یا دولتی که تایید کننده موارد بالا باشد نیز کافی است..</p>',
  bankwire_noncompany_desc: '<p>این کار شما را از صفحه شخصی خارج کرده و به صفحه ثبت نام حساب شرکت ارجاع می دهد.</p><p>آیا مایل به ادامه هستید?</p>',
  please_enter_card_detail_and_amount: 'لطفا اطلاعات کارت و مبلغی که مایل به واریز هستید را وارد کنید',
  important: 'مهم',
  please_note_that_the_maximum_deposit_amount: 'لطفا توجه داشته باشید که حداکثر مقدار واریزی در هر روز , 1000 دلار برای هر کارت است',
  city: 'شهر',
  zip: 'کد پستی',
  please_note_that_after_three_unsuccessful_attempts: 'لطفا توجه داشته باشید که پس از 3 تلاش ناموفق ویزا/ مستر کارت برای مدت 24 ساعت از دسترس خارج می شوند.',
  epay_pro_desc:
    '<p>معامله گر عزیز <br><br>متأسفانه, به دلیل برخی از مشکلات فنی و محدودیت ها ، سپرده های کارت اعتباری از طریق ارائه دهنده ماEPayPro موقتاً غیرفعال می شوند.<br><br>ویزا و مستر کارت در ساعت 23:00 GMT 04/04/2018 غیر فعال خواهند شد . پس از غیر فعال شدن ارائه دهنگان خدمات واریزی ها نیز موقتا غیر فعال می شوند. اگرچه ارائه دهندگان پرداخت ما یک زمان دقیق برای خرابی را به ما ارائه نکرده اند ، اما ما در تلاش هستیم تا در اسرع وقت گزینه های دیگری را اعمال کنیم..<br><br>ما در تلاش هستیم تا با ارائه دهندگان خود مشکلات فعلی را برطرف کنیم تا در آینده ، حساب ها بتوانند پردازش سپرده های را بدون تأخیر از سر بگیرند.<br><br>درصورتی که سوال دیگری داشتید می توانید با تیم پشتیبانی ما تماس بگیرید.</p>',
  provider_redirect: 'شما به {provider} ارجاع داده خواهید شد..',
  lydiax_note: 'حداقل مبلغ واریز 30 دلار/ یورو خواهد بود',
  lydiax_note1:
    'اگر کمتر از 30 دلار/ یورو از ارزش یک {crypto} را واریز کنید, شما باید یک ایمیل به persiansupport@eurotrader.com زده و تقاضای برگشت وجه را بدهید, باید آدرس {crypto} که مایل به برگشت وجه به آن هستید را ارائه کنید.',
  lydiax_note2:
    'لطفاً مقدار {crypto} مورد نظر برای واریز را وارد کنید تا تخمینی از آنچه بدست می آورید را ببینید. به خاطر داشته باشید که قیمت های زیر فقط برای زمانی که درخواست شده اند معتبر هستند و هر لحظه می توانند تغییر کنند.',
  lydiax_note3: 'ما یک آدرس واریز برای استفاده شما ایجاد خواهیم کرد.',
  lydiax_note4: 'لطفا از آدرس زیر برای واریز {crypto} استفاده کنید.',
  lydiax_note5: 'از این پس, این آدرس مخصوص برای واریز {crypto} , مورد استفاده قرار خواهد گرفت',
  lydiax_required_address: 'اگر تگ و آدرس جداگانه برای کیف پول نیاز است استفاده کنید :',
  tag: 'تگ',
  lydiax_enter_deposit: 'لطفا ارز دیجیتالی  که مایل به واریز هستید را انتخاب کنید',
  create_address: 'ایجاد آدرس',
  please_note: 'لطفا توجه داشته باشید:',
  price_estimate: 'تخمین قیمت :',
  check_price: 'بررسی قیمت',
  vload_please_enter_voucher: 'لطفا شماره پین کوپن Vload خود را وارد کنید',
  vload_minimum: '<p>(حداقل مبلغ کوپن مورد قبول<b>50</b> یورو یا دلار می باشد!)</p>',
  vload_vouchers: 'من نیاز به خرید  کوپن Vload را  دارم',
  vload_note: 'پرداخت بدون دردسر از طریق ویزا و مستر کارت همانند انتقال الکترونیکی بانکی.<br />درباره Vload بیشتر بدانید یا یک کوپن ]یورو/ دلار[ Vload خریداری کنید. متخصص.',
  vload_note1: 'به منظور واریز از طریق Vload حساب شما باید ابتدا تایید شود!',
  reason: 'دلیل :',
  attempts: 'تلاش  {attempts} از {maxAttempts},',
  two_more_remaining: 'دو(2) تلاش دیگر باقی مانده.',
  one_more_remaining: 'تنها یک(1) تلاش دیگر باقی مانده.',
  please_contact_bank: '<br />لطفا با بانک صادر کننده کارت تماس بگیرید.<br /> ممکن است کارت شما برای تراکنش های بین المللی مسدود شده باشد',
  edata_success_note:
    'لطفا توجه داشته باشید که ممکن است مبلغ اضافی برای واریزی شما وجود داشته باشد که توسط بانک صادر کننده شما به دلیل معامله بین المللی ایجاد شده است. این هزینه کمی خواهد بود اما از بانکی به بانک دیگر متفاوت خواهد بود. <br><br>این تراکنش کارت اعتباری در صورتحساب شما با عنوان "Tech Savvy Billing" ، "Business Billing" یا "Business media Billing" ظاهر می شود “.',
  you_can_try: 'شما می توانید مجددا تلاش کنید',
  here: 'اینجا',
  safe_charged_success_message: 'واریز شما در کمتر از 2 روز کاری توسط شرکت ما پردازش خواهد شد.',
  thank_you: 'با تشکر از شما !',
  your_deposit_successful: 'واریز شما با موفقیت انجام شد',
  card_redirect: 'شما برای وارد کردن اطلاعات شخصی و کارت اعتباری ارجاع داده خواهید شد',
  bank_wire_withdrawal_note:
    'در صورت عدم قبول انتقال الکترونیکی بانكی از طرف بانك دریافت كننده به دلیل اطلاعات اشتباه بانكی كه توسط مشتری ارائه می شود ، هزینه های مختلف اجرای انتقال بانكی كه توسط بانك های دیگر اخذ شده است ، قبل از تخصیص اعتبار به کیف پول مشتری از مبلغ برداشت درخواستی کسر می شود. ',
  please_enter_amount_withdraw: 'لطفا مبلغی که مایل به برداشت هستید را وارد کنید',
  bitcoin_note: 'لطفا آدرس بیتکوین و مبلغی که مایل به برداشت هستید را وارد کنید',
  otp: 'پسورد یکبار مصرف (OTP)',
  otp_send_email: 'ارسال OTP به ایمیل',
  otp_additional_text: 'پسورد یکبار مصرف فوق برای درخواست برداشت بیتکوینی است که در حال انجام هستید',
  otp_new_password: 'یک پسورد یکبار مصرف جدید به ایمیل شما ارسال شد',
  otp_error: 'خطا - پسورد یکبار مصرف ارسال نشد',
  lydiax_withdrawal_note:
    'لطفاً مبلغ {currency} مورد نظر برای برداشت را وارد کنید تا تخمینی از {crypto} دریافت شده را ببینید. به خاطر داشته باشید که قیمت های زیر تنها در زمان درخواست معتبر هستند و هر لحظه می توانند تغییر کنند.',
  enter_currency_amount: 'برای مشاهده تخمین, مبلغ {currency} را وارد کنید',
  lydiax_withdrawal_additional_note: 'پسورد یکبار مصرف فوق برای درخواست برداشت ارز دیجیتالی است که در حال انجام هستید',
  estimated: 'تخمین:',
  please_enter_your_crypto_address: 'لطفا آدرس {crypto} و مقداری که مایل به برداشت هستید را وارد کنید',
  select_cryptocurrency: 'ارز دیجیتال را انتخاب کنید',
  request_amount: 'مبلغ درخواست شده',
  amount_changes: 'مبلغ شارژ (شامل هزینه)',
  operation_failed: 'عملیات انجام نشد! درخواست شما نامعتبر است',
  operation_failed_error: 'عملیات انجام نشد! خطایی در پردازش این درخواست رخ داده است',
  are_you_sure_create_master: 'آیا اطمینان دارید که می خواهید یک حساب جدید ایجاد کرده و به این حساب اصلی متصل کنید؟',
  are_you_sure_attach_selected_account_to_master: 'آیا اطمینان دارید که می خواهید حساب انتخاب شده را به این حساب اصلی متصل کنید؟',
  change_password_desc:
    '<strong>*</strong> این تغییر پسورد, تاثیری بر روی پسورد حساب معاملاتی شما ندارد. برای تغییر پسورد حساب معاملاتی خود <strong>لیست حساب </strong> را مشاهده کرده و از گزینه <strong>تغییر پسورد </strong>که داخل علامت چرخ دنده تعبیه شده, استفاده کنید.',
  client_assessment: 'ارزیابی مشتری',
  select_answer: 'یک جواب را انتخاب کنید...',
  declarations: 'اعلامیه',
  complele_profile_desc: 'آیا در حال حاضر یا در هر زمان دیگری, درگیر فعالیت مجرمانه بوده اید یا اینکه جرایم کیفری مهمی علیه شما در دادگاه در حال رسیدگی است؟',
  complete_profile_desc1:
    'آیا شما, وابستگان یا نزدیکان شما اشخاص سیاسی هستید؟ اشخاص سیاسی, اشخاص حقیقی هستند که در طی 12 ماه گذشته وظایف برجسته عمومی به آنها واگذار شده است ، یعنی روسای دولت ، سیاستمداران ارشد ،  مقامات ارشد دولتی ، مقامات قضایی یا نظامی ، مدیران ارشد شرکتهای دولتی ، مقامات حزب سیاسی',
  are_you_us_citizen: 'آیا شما شهروند  یا مقیم ایالات متحده با تعهدات مالیاتی هستید؟',
  please_check_forms_errors: 'لطفا فرم ها را برای خطا را بررسی کنید',
  profile_succesfully_completed: 'پروفایل با موفقیت کامل شد',
  please_select_country: 'لطفا کشور خود را انتخاب کنید',
  set_country: 'تنظیم کشور',
  empty_country_code: 'کد  کشور خالی است, لطفا صفحه را دوباره باز کرده و مجددا تلاش کنید.',
  invalid_country_code: 'کد  کشور نامعتبر است, لطفا صفحه را دوباره باز کرده و مجددا تلاش کنید.',
  individual_company: 'شما یک شخص هستید یا یک شرکت؟',
  prev: 'قبل',
  previous: 'قبل',
  complete: 'کامل',
  please_select_an_option: 'لطفا یک گزینه را برای هر بخش انتخاب کنید!',
  swap: 'سواپ',
  buy: 'خرید',
  sell: 'فروش',
  sums: 'جمع',
  net_total: 'مجموع خالص',
  deposit_page_desc:
    '<p class = "has-text-white is-size-5-desktop is-size-6-tablet is-size-6-mobile has-text-weight-bold" >  همین حالا ثبت نام کنید و</p><p class = "is-size-1-desktop is-size-2-tablet is-size-3-mobile has-text-weight-bold vload-promo-large-text">کسب کنید <span class = "has-text-white has-text-weight-bold"> رایگان </span> <br/> 10 یورو / دلار<br/> eVoucher</p>',
  deposit_page_desc1: 'کوپن  10 یورو/ دلاری پاداش فعال خواهد شد به محض اینکه',
  create_new_account: ' یک حساب جدید ایجاد کنید',
  successfully_purchase_vload: 'یک کوپن الکترونیک Vload با مبلغ دلخواه با موفقیت خریداری و کسب شد',
  upgrade_to_tier_2: 'ارتقاء به سطح 2',
  register_now: 'اکنون ثبت نام کنید',
  back: 'برگشت',
  my_card_desc: 'از اینجا می توانید تمامی کارت هایی که برای پرداخت استفاده کرده اید و وضعیت فعلی آنها را در سیستم ما مشاهده کنید',
  you_have_no_card: 'شما تا کنون واریزی از طریق کارت نداشته اید',
  card_no: 'شماره کارت',
  last_used: 'آخرین استفاده',
  risk_warning: 'هشدار خطر',
  upload_documents_note: 'اگر مایل به واریز با کارت هستید, لطفا مدارک بیشتری را برای بررسی و تایید به ما ارائه کنید.',
  please_select_your_country: 'لطفا ابتدا کشور خود را انتخاب کنید',
  add_another_document: 'یک مدرک دیگر اضافه کنید',
  drop_files_upload: 'برای بارگذاری, مدارک را در این قسمت قرار دهید.',
  date_until: 'تا تاریخ ',
  copy: 'کپی',
  cvv: 'CVV',
  please_enter_crypto_amount: 'مقدار {crypto} را وارد کنید.',
  vload_pin: 'رمز Vload',
  deposit_info:
    'ارائه دهنده خدمات پرداخت در حال حاضر با مشکل روبروست و واریز مستقیم ویزا و مسترکارت در حال حاضر در دسترس نیست. به صورت جایگزین و برای واریز از طریق ویزا و مستر کارت می توانید از Vload استفاده کنید.',
  id: 'شناسه',
  pamm_modal_error: 'ورودی نامعتبر برای نمایش نام. لطفا این بخش را خالی نگذاشته و بیشتر از 32 حرف نیز وارد نکنید.',
  pamm_modal_error1: 'مقدار نامعتبر برای حداقل واریزی وارد شده. لطفا یک عدد مثبت کمتر از 1,000,000 وارد کنید.',
  error_missing_required_field: 'خطا, یک بخش مورد نیاز  پر نشده.',
  page_not_found: 'صفحه یافت نشد',
  new_version_note: 'نسخه جدید یافت شد, لطفا برای بازیابی صفحه اینجا کلیک کنید.',
  new_version_note1: 'بعضی عملکردها ممکن است در دسترس نباشد تا زمانی که صفحه را بازیابی کنید.',
  records: 'ضبط',
  gateway: 'درگاه',
  client: '',
  commission_amount: '',
  tier_name: '',
  trades_completed: '',
}



// WEBPACK FOOTER //
// ./src/locale/fa.js